import { useState } from "react";
import {
  IconCreditCard,
  IconPencil,
  IconCheck,
  IconBuilding,
  IconMail,
  IconMapPin,
} from "@tabler/icons-react";
import styles from "../subscriptionPayment.module.css";
import Input from "../../../../components/UI/FormInput/input";
import Button from "../../../../components/UI/Button/button";

export default function BillingInfoCard({ info, onSave }) {
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState(info);

  function startEdit() {
    setForm(info);
    setEditing(true);
  }

  function cancelEdit() {
    setEditing(false);
  }

  function handleSave() {
    // Ported verbatim: only non-empty trimmed fields overwrite the
    // existing value (`if (company) ... `), matching saveBillingEdit().
    const company = form.company.trim();
    const billingEmail = form.billingEmail.trim();
    const address = form.address.trim();
    onSave({
      company: company || info.company,
      billingEmail: billingEmail || info.billingEmail,
      address: address || info.address,
    });
    setEditing(false);
  }

  const setField = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconCreditCard size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Billing Info</div>
          </div>
        </div>
      </div>

      <div className={`${styles.cardBody} ${styles.cardBodyTopPad14}`}>
        {!editing ? (
          <>
            <div className={styles.infoCardRow}>
              <div
                className={styles.infoCardIcon}
                style={{ background: "#eff2ff", color: "var(--blue)" }}
              >
                <IconBuilding size={15} />
              </div>
              <div>
                <div className={styles.infoCardLabel}>Company</div>
                <div className={styles.infoCardValue}>{info?.companyName}</div>
              </div>
            </div>
            <div className={styles.infoCardRow}>
              <div
                className={styles.infoCardIcon}
                style={{ background: "#fef3c7", color: "#d97706" }}
              >
                <IconMail size={15} />
              </div>
              <div>
                <div className={styles.infoCardLabel}>Billing Email</div>
                <div className={styles.infoCardValue}>{info?.email}</div>
              </div>
            </div>
            <div className={styles.infoCardRow}>
              <div
                className={styles.infoCardIcon}
                style={{ background: "#f0fdf4", color: "#10b981" }}
              >
                <IconMapPin size={15} />
              </div>
              <div>
                <div className={styles.infoCardLabel}>Address</div>
                <div className={styles.infoCardValue}>{info?.companyAddress}</div>
              </div>
            </div>
          </>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <Input
              label="Company"
              id="e-company"
              type="text"
              value={form.company}
              onChange={setField("company")}
            />
            <Input
              label="Billing Email"
              id="e-billingEmail"
              type="email"
              value={form.billingEmail}
              onChange={setField("billingEmail")}
            />
            <Input
              label="Address"
              id="e-address"
              type="text"
              value={form.address}
              onChange={setField("address")}
            />
            <div className="flex pt-1 gap-2">
              <Button
                variant="secondary"
                className="flex-1"
                // fullWidth
                leftIcon={<IconCheck size={15} />}
                onClick={handleSave}
              >
                Save
              </Button>
              <Button
                variant="outlineBlue"
                className="flex-1"
                // fullWidth
                onClick={cancelEdit}
              >
                Cancel
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
